import * as Yup from 'yup';

const personAddressLinkSchema = Yup.object({
  ptsAddressID: Yup.number().nullable().required('An address must be selected'),
});

export default personAddressLinkSchema;
